import { useParams } from 'react-router-dom';
import { all } from '../data/all';

function GenericFirstLevel() {
    const { country, first } = useParams();

    let countryData = [];
    
    all.forEach(thisCountry => {
        if (thisCountry.name.common === country) {
            countryData = JSON.stringify(thisCountry[first]);
        }
    })    

    return(
        <code>
            { countryData }
        </code>
    )
}

export default GenericFirstLevel;